export const Rings = ({ className = "", stroke = "#EE3A90", stroke2 = null }) => (
    <svg
        viewBox="0 0 400 400"
        fill="none"
        aria-hidden="true"
        className={`ring-spin ${className}`}
    >
        {[40, 80, 120, 160, 196].map((r, i) => (
            <circle
                key={r}
                cx="200"
                cy="200"
                r={r}
                stroke={stroke2 && i % 2 === 1 ? stroke2 : stroke}
                strokeOpacity={0.55 - i * 0.09}
                strokeWidth={i % 2 === 0 ? 2.5 : 1.4}
                strokeDasharray={i % 2 === 1 ? "3 9" : undefined}
            />
        ))}
    </svg>
);

export const Dots = ({ className = "" }) => (
    <svg viewBox="0 0 120 120" aria-hidden="true" className={className}>
        {[0, 1, 2, 3].map((row) =>
            [0, 1, 2, 3].map((col) => (
                <circle
                    key={`${row}-${col}`}
                    cx={14 + col * 30}
                    cy={14 + row * 30}
                    r={row === col ? 9 : 5}
                    fill={row === col ? "#FFD93D" : "#FFA3D3"}
                    fillOpacity={row === col ? 1 : 0.7}
                />
            )),
        )}
    </svg>
);
